/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { KopiaRoboczaIdent } from '../../models/kopia-robocza-ident';

export interface ApiWebInstytucjeNipRoboczePost$Params {
  nip: string;
}

export function apiWebInstytucjeNipRoboczePost(http: HttpClient, rootUrl: string, params: ApiWebInstytucjeNipRoboczePost$Params, context?: HttpContext): Observable<StrictHttpResponse<{

/**
 * Identyfikator nadawany przez backend, nie wypełniać przy tworzeniu.
 */
'id'?: number;

/**
 * Data utworzenia nadawana przez backend, nie wypełniać.
 */
'dataUtworzenia'?: string;

/**
 * Identyfikator SSO użytkownika, który utworzył kopię, nadawany przez backend.
 */
'ssoIdUtworzenia'?: string;

/**
 * Data modyfikacji nadawna przez backend.
 */
'dataModyfikacji'?: string;

/**
 * Identyfikator SSO użytkownika, który zmodyfikował kopię, nadawany przez backend.
 */
'ssoIdModyfikacji'?: string;

/**
 * Data przydatności do spożycia, nadawana przez backend.
 */
'dataWygasniecia'?: string;

/**
 * Identyfikator GoAML użytkownika oznaczonego jako wysyłający raport.
 */
'uzytkownikGoAML': string;

/**
 * Lista identyfikatorów transakcji w tej kopii roboczej.
 */
'identyfikatory': Array<KopiaRoboczaIdent>;

/**
 * Dane kopii roboczej, jako pojedynczy string, backend przekazuje tylko przy pobieraniu pojedynczej kopii.
 */
'dane': string;
}>> {
  const rb = new RequestBuilder(rootUrl, apiWebInstytucjeNipRoboczePost.PATH, 'post');
  if (params) {
    rb.path('nip', params.nip, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<{
      
      /**
       * Identyfikator nadawany przez backend, nie wypełniać przy tworzeniu.
       */
      'id'?: number;
      
      /**
       * Data utworzenia nadawana przez backend, nie wypełniać.
       */
      'dataUtworzenia'?: string;
      
      /**
       * Identyfikator SSO użytkownika, który utworzył kopię, nadawany przez backend.
       */
      'ssoIdUtworzenia'?: string;
      
      /**
       * Data modyfikacji nadawna przez backend.
       */
      'dataModyfikacji'?: string;
      
      /**
       * Identyfikator SSO użytkownika, który zmodyfikował kopię, nadawany przez backend.
       */
      'ssoIdModyfikacji'?: string;
      
      /**
       * Data przydatności do spożycia, nadawana przez backend.
       */
      'dataWygasniecia'?: string;
      
      /**
       * Identyfikator GoAML użytkownika oznaczonego jako wysyłający raport.
       */
      'uzytkownikGoAML': string;
      
      /**
       * Lista identyfikatorów transakcji w tej kopii roboczej.
       */
      'identyfikatory': Array<KopiaRoboczaIdent>;
      
      /**
       * Dane kopii roboczej, jako pojedynczy string, backend przekazuje tylko przy pobieraniu pojedynczej kopii.
       */
      'dane': string;
      }>;
    })
  );
}

apiWebInstytucjeNipRoboczePost.PATH = '/api/web/instytucje/{nip}/robocze';
